import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "document-reviewer-agent";
const keys = addTranslations(RESOURCE_NAME, {
    empty_state_title: {
        en: "Document Reviewer",
        fr: "Revue de document",
    },
    title_chip_title: {
        en: "Document reviewer",
        fr: "Revue de document",
    },
    score_response_success: {
        en: "Feedback sent successfully",
        fr: "Feedback envoyé avec succès",
    },
    score_response_error: {
        en: "Feedback not sent",
        fr: "Feedback non envoyé",
    },
    error_message: {
        en: "Something went wrong, and the Document Reviewer can't continue the conversation. To keep using it, you'll need to reload the page. \n Important: Reloading will erase your current conversation. If there's anything you want to keep, please copy the text and save it elsewhere.",
        fr: "Une erreur inattendue est survenue et le revueur de document ne peut pas continuer la conversation. Pour continuer à l'utiliser, vous devrez recharger la page. \n Important: Le rechargement effacera votre conversation actuelle. Si vous souhaitez conserver quelque chose, veuillez copier le texte et l'enregistrer ailleurs.",
    },
    input_placeholder: {
        en: "Upload a policy",
        fr: "Importer une politique",
    },
    example_message_chip_policy_missing: {
        en: "Can you review this policy and tell me what’s missing?",
        fr: "Peux-tu relire cette politique et m’indiquer ce qu’il manque ?",
    },
    example_message_chip_policy_strengthen: {
        en: "How can I strengthen the commitments in this environmental policy?",
        fr: "Comment améliorer les engagements de cette politique environnementale ?",
    },
    example_message_chip_policy_dei: {
        en: "Does this DEI policy meet industry standards?",
        fr: "Est-ce que cette politique DEI est conforme aux standards de mon industrie ?",
    },
    example_message_chip_policy_anti_corruption: {
        en: "What improvements would you recommend for this anti-corruption policy?",
        fr: "Comment puis-je améliorer cette politique anti-corruption ?",
    },
});

export function useDocumentReviewerAgentTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
